import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { globalStyles } from './style/gstheme';
import PropTypes from 'prop-types';

const styles = theme => {
  return Object.assign({
    actionText: {
      textAlign: 'center',
      fontSize: '16px',
      color: theme.palette.primary.main
    }
  }, globalStyles);
};

class ActionText extends React.Component {

  render() {

    const { classes, children, offset, dataTest, bottom } = this.props;

    return (
      <div style={{ marginTop: offset, marginBottom: bottom }}>
        <Typography data-test={dataTest || "action-text"} className={classes.actionText}>{children}</Typography>
      </div>
    );
  }
}

ActionText.defaultProps = {
  offset: '0px',
  bottom: '0px'
};

ActionText.propTypes = {
  offset: PropTypes.string.isRequired,
  classes: PropTypes.object,
  bottom: PropTypes.string,
  children: PropTypes.any,
  dataTest: PropTypes.string,
};

export default withStyles(styles)(ActionText);